import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { ApiUrl } from '../conf/config';
import { ReqAddEditUser } from '../types/api/Users';

export const useAddUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const history = useHistory();

  const addUser = useCallback(async (user: ReqAddEditUser) => {
    setError(false);
    setLoading(true);

    const token = sessionStorage.getItem('token');

    try {
      const res = await axios.post(`${ApiUrl}/admin/api/v1/users`, user, {
        headers: { Authorization: 'Bearer ' + token },
      });
      if (res.status === 200 && res.data.account_id !== '') {
        alert('ユーザーを登録しました。');
        history.push(`/accounts/details/${res.data.account_id}?tab=1`);
      }
    } catch (e) {
      console.error(e);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  return { addUser, loading, error };
};
